'use client';

import { type FC, type PropsWithChildren } from 'react';
import { type AbstractIntlMessages, NextIntlClientProvider } from 'next-intl';

interface I18nProviderProps {
  locale: string;
  messages: AbstractIntlMessages;
}

export const I18nProvider: FC<PropsWithChildren<I18nProviderProps>> = ({ locale, messages, children }) => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  return (
    <NextIntlClientProvider locale={locale} messages={messages} now={new Date()} timeZone={timeZone}>
      {children}
    </NextIntlClientProvider>
  );
};
